import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";
import { Link } from "react-router-dom";

import { getRoomImages } from "src/utils/Firebase";
import css from "./index.scss";

const cx = classnames.bind(css);
const moduleName = "Room";

const Room = ({ id, folder, title, content, size, reverse }) => {
  const [imgUrl, setImgUrl] = useState("");

  useEffect(() => {
    getRoomImages(folder).then((urls) => {
      if (urls.length > 0) setImgUrl(urls[0]);
    });
  }, [folder]);

  return (
    <div className={cx(moduleName, { reverse })} data-aos={reverse ? "fade-left" : "fade-right"}>
      <div className={cx(`${moduleName}-image`)}>
        {imgUrl && <img src={imgUrl} alt={title} />}
        {size && <div className={cx(`${moduleName}-size-badge`)}>{size}평형</div>}
      </div>
      <div className={cx(`${moduleName}-info`)}>
        <p className={cx(`${moduleName}-info-label`)}>Room</p>
        <h2 className={cx(`${moduleName}-info-title`)}>{title}</h2>
        <div className={cx(`${moduleName}-info-divider`)} />
        <p className={cx(`${moduleName}-info-content`)}>{content}</p>
        <Link
          to={{ pathname: `/room/${id}`, state: { folder } }}
          className={cx(`${moduleName}-info-btn`)}
        >
          자세히 보기
        </Link>
      </div>
    </div>
  );
};

export default Room;



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Rooms/components/Room/index.js